import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "https://login.abhedasramam.org/myapp/api/get_emagazine.php";

const EmagazineList = () => {
  const [groupedData, setGroupedData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEmagazines();
  }, []);

  const fetchEmagazines = async () => {
    try {
      const res = await axios.get(API_URL);

      const data = res.data || [];

      // ✅ Group by year
      const grouped = data.reduce((acc, item) => {
        const year = item.year;

        if (!acc[year]) {
          acc[year] = [];
        }

        acc[year].push(item);
        return acc;
      }, {});

      // ✅ Sort months inside each year (latest first)
      Object.keys(grouped).forEach((year) => {
        grouped[year].sort((a, b) => b.month - a.month);
      });

      setGroupedData(grouped);
    } catch (error) {
      console.error("Error fetching emagazines:", error);
    } finally {
      setLoading(false);
    }
  };

  const getMonthName = (month) => {
    const months = [
      "January", "February", "March", "April",
      "May", "June", "July", "August",
      "September", "October", "November", "December"
    ];
    return months[parseInt(month) - 1] || month;
  };

  const openUrl = (url) => {
    window.open(url, "_blank");
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div>
      {Object.keys(groupedData).length === 0 ? (
        <p>No emagazines found</p>
      ) : (
        Object.keys(groupedData)
          .sort((a, b) => b - a) // 🔥 sort years latest first
          .map((year) => (
            <div key={year} style={styles.yearBlock}>
              
              {/* Year Heading */}
              <h2 style={styles.year}>{year}</h2>

              {/* Buttons */}
              <div style={styles.container}>
                {groupedData[year].map((item, index) => (
                  <button
                    key={index}
                    style={styles.button}
                    onClick={() => openUrl(item.url)}
                  >
                    {getMonthName(item.month)} {item.year}
                  </button>
                ))}
              </div>

            </div>
          ))
      )}
    </div>
  );
};

export default EmagazineList;

// 🔹 Styles
const styles = {
  yearBlock: {
    marginBottom: "25px",
  },
  year: {
    marginBottom: "10px",
    color: "#333",
    fontSize:"18pt",
    fontWeight:"600",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
  },
  button: {
    padding: "10px 15px",
    backgroundColor: "#ffc107",
    color: "black",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
  },
};